import { render, staticRenderFns } from "./heard-course.vue?vue&type=template&id=6b7a5368&scoped=true&"
import script from "./heard-course.vue?vue&type=script&lang=js&"
export * from "./heard-course.vue?vue&type=script&lang=js&"
import style0 from "./heard-course.vue?vue&type=style&index=0&id=6b7a5368&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7a5368",
  null
  
)

export default component.exports